import tonStyles from './../ton.json'

export default {
  infoColor: tonStyles.colors.PrimaryBlack,
  infoBgColor: tonStyles.colors.PrimaryWhite,
  infoBorderColor: tonStyles.colors.PrimaryBlack,
  successColor: tonStyles.colors.TertiaryGreen,
  successBgColor: tonStyles.colors.PrimaryWhite,
  successBorderColor: tonStyles.colors.TertiaryGreen,
  errorColor: tonStyles.colors.SecondaryRed,
  errorBgColor: tonStyles.colors.PrimaryWhite,
  errorBorderColor: tonStyles.colors.SecondaryRed
}
